import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AnnouncementBanner.css";

const AnnouncementBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    navigate("/announcement");
  };

  // Don't show the banner on the announcement page itself
  if (location.pathname === "/announcement") {
    return null;
  }

  return (
    <div className="announcement-banner" onClick={handleClick}>
      <div className="announcement-banner-content">
        <span className="announcement-text">
          BoomLand Official Announcement
        </span>
        <span className="announcement-arrow">→</span>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
